export enum UserRole {
  admin = "Client Admin",
  user = "User",
}